<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
          <div class="padding">
          <p>At the weekend I was with Oska near the Portus perolink, when he grabbed my hand and pointed his tiny mitten toward the old flow tunnel entrance, I tried to explain it to him, but he didn't understand.</p>
<br>
          <p>The thing is that I'm sure there used to be another building behind it, a larger concrete one, giant doors for trucks or something, but it's not there now, and I don't remember it going, but this time it wasn't just me. I asked Kathy about it and she didn't remember it either, but they said they did have a similar feeling about the humdrum that used to be on the street behind their house. She was sure it had kept them awake for weeks, the same night at the same time, and then it didn't. I asked if she'd just got used to it and stopped noticing, the way I did with the voicering outside the window the summer before, but she said no, that wasn't it.</p>
<br>
          <p>Two lost buildings we don't remember, and me describing all this to a lost person, seems the winter did me no good.</p>
<br>
          <p>Writing to you is at least cheaper than a therapist, and anyway it's hard to find one that deals with anything more than just spacing these days. It feels ok though, writing these things, even just noting them seems to fix them more.</p>
<br>
          <p>I looked back up the page and already I don't remember the building I was talking about, and more and more I hear the same from other people. Maybe it's a mass spiritual crisis, all that reliving and blotting, the memory that we always knew was fluid, suddenly flowing strongly, and flowing away from us. They talk about the intersect on the news and the science streams, and it scares me.</p>
<br>
          <p>When I look at Oska I concentrate now, I really concentrate, and you know I find myself worrying about what happens when I blink.</p>
           <p> &nbsp;</p>
          <p> &nbsp;</p>
          </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Blink'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
